// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { Link, useParams } from "react-router-dom";

// const ProductView = () => {
//   const [ProductUser, setProductUser] = useState({
//     prod_image: "",
//     product_name: "",
//     prod_price: "",
//     prod_Product: "",
//     prod_stock: "",
//     prod_vendor_assign: "",
//     prod_size: "",
//     status: "",
//   });

//   const { id } = useParams();

//   useEffect(() => {
//     const ProductData = async () => {
//       try {
//         const response = await axios.post(
//           "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_product_by_id",
//           { prod_id: id }
//         );

//         if (response.data && response.data.result) {
//           setProductUser(response.data.result);
//         } else {
//           console.error("No data found for this product ID");
//         }
//       } catch (error) {
//         console.error("Error fetching product data!", error);
//       }
//     };
//     ProductData();
//   }, [id]);

//   return (
//     <div className="page-content">
//       {/* Start Container Fluid */}
//       <div className="container-fluid">
//         {/* ========== Page Title Start ========== */}
//         <div className="row">
//           <div className="col-12">
//             <div className="page-title-box d-flex justify-content-between align-items-center">
//               <div>
//                 <h4 className="mb-0 fw-semibold">Product View</h4>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <Link to="/Product-list">Product</Link>
//                   </li>
//                   <li className="breadcrumb-item active">Product View</li>
//                 </ol>
//               </div>
//               <Link to="/Product-list" className="btn btn-outline-secondary">
//                 <i className="fa-solid fa-arrow-left"></i> Back to List
//               </Link>
//             </div>
//           </div>
//         </div>
//         {/* ========== Page Title End ========== */}

//         <div className="row mt-3">
//           <div className="col-xl-10 mx-auto">
//             <div className="card p-4 Product-view position-relative">
//               <div className="cross-icon position-absolute top-0 end-0 m-3">
//                 <Link to="/Product-list">
//                   <i
//                     className="fa-solid fa-circle-xmark text-danger"
//                     style={{ fontSize: "24px" }}
//                   ></i>
//                 </Link>
//               </div>

//               <div className="text-center mb-4">
//                 {ProductUser.prod_image ? (
//                   <img
//                     src={`https://cyberathon.com/multivendor/${ProductUser.prod_image}`}
//                     alt="Product"
//                     width={400}
//                     height={300}
//                     style={{
//                       borderRadius: "10px",
//                       objectFit: "cover",
//                       boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
//                     }}
//                   />
//                 ) : (
//                   <p>No Image Available</p>
//                 )}
//               </div>

//               <div className="product-info">
//                 <strong>Product Name:</strong>
//                 <p>{ProductUser.product_name}</p>

//                 <strong>Product Price:</strong>
//                 <p>{ProductUser.prod_price}</p>

//                 <strong>Created By:</strong>
//                 <p>{ProductUser.prod_Product}</p>

//                 <strong>Total Stock:</strong>
//                 <p>{ProductUser.prod_stock}</p>

//                 <strong>Vendor Assign:</strong>
//                 <p>{ProductUser.prod_vendor_assign}</p>

//                 <strong>Size:</strong>
//                 <p>{ProductUser.prod_size}</p>

//                 <strong>Status:</strong>
//                 <p>{ProductUser.status}</p>
//               </div>

//               <div className="mt-4 text-center">
//                 <Link
//                   to={`/Product-edit/${id}`}
//                   className="btn btn-primary me-2"
//                 >
//                   <i className="fa-solid fa-pen-to-square me-1"></i> Edit Product
//                 </Link>
//                 <Link to="/Product-list" className="btn btn-outline-secondary">
//                   Cancel
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ========== Footer Start ========== */}
//       <footer className="footer mt-4">
//         <div className="container-fluid">
//           <div className="row">
//             <div className="col-12 text-center">
//               © Venton. Crafted by{" "}
//               <i className="fa-solid fa-heart text-danger"></i>{" "}
//               <Link to="#" className="fw-bold footer-text" target="_blank">
//                 Techzaa
//               </Link>
//             </div>
//           </div>
//         </div>
//       </footer>
//       {/* ========== Footer End ========== */}
//     </div>
//   );
// };

// export default ProductView;




// import React, { useState, useEffect } from "react";
// // import Footer from "./Footer";
// // import SupplierInfoModal from "./SupplierInfoModel";
// import { Link } from "react-router-dom";

// // ProductImages Component with custom zoom functionality
// const ProductImages = ({ images }) => {
//   const baseURL = "https://cyberathon.com/multivendor/";
//   const defaultImages = [
//     "img/acc16.webp",
//     "img/acc7.webp",
//     "img/acc8.webp",
//     "img/acc6.webp"
//   ];

//   // Use API images if available, otherwise use default
//   const imageList = images && images.length > 0 
//     ? images.map(img => `${baseURL}${img}`)
//     : defaultImages;

//   const [mainImage, setMainImage] = useState(imageList[0]);
//   const [isOpen, setIsOpen] = useState(false);
//   const [showZoom, setShowZoom] = useState(false);
//   const [zoomPosition, setZoomPosition] = useState({ x: 0, y: 0 });

//   // Update main image when images prop changes
//   useEffect(() => {
//     if (imageList.length > 0) {
//       setMainImage(imageList[0]);
//     }
//   }, [images]);

//   const handleMouseMove = (e) => {
//     const { left, top, width, height } = e.target.getBoundingClientRect();
//     const x = ((e.clientX - left) / width) * 100;
//     const y = ((e.clientY - top) / height) * 100;
//     setZoomPosition({ x, y });
//   };

//   return (
//     <>
//       <div className="col-lg-5">
//         {imageList.map((img, i) => (
//           <img
//             key={i}
//             onClick={() => setMainImage(img)}
//             src={img}
//             alt={`Product thumbnail ${i + 1}`}
//             style={{
//               width: '110px',
//               margin: '5px',
//               border: img === mainImage ? '2px solid blue' : '1px solid gray',
//               borderRadius: '5px',
//               cursor: 'pointer'
//             }}
//           />
//         ))}
//       </div>

//       {/* Main Image with Custom Zoom */}
//       <div className="col-lg-7" style={{ position: 'relative' }}>
//         <div 
//           style={{ 
//             position: 'relative',
//             overflow: 'hidden',
//             cursor: 'zoom-in'
//           }}
//           onMouseEnter={() => setShowZoom(true)}
//           onMouseLeave={() => setShowZoom(false)}
//           onMouseMove={handleMouseMove}
//           onClick={() => setIsOpen(true)}
//         >
//           <img 
//             src={mainImage} 
//             alt="Product"
//             style={{
//               width: '100%',
//               display: 'block'
//             }}
//           />
          
//           {/* Zoom Lens */}
//           {showZoom && (
//             <div
//               style={{
//                 position: 'absolute',
//                 top: 0,
//                 left: 0,
//                 width: '100%',
//                 height: '100%',
//                 backgroundImage: `url(${mainImage})`,
//                 backgroundPosition: `${zoomPosition.x}% ${zoomPosition.y}%`,
//                 backgroundSize: '250%',
//                 backgroundRepeat: 'no-repeat',
//                 pointerEvents: 'none',
//                 border: '2px solid rgba(0,0,0,0.1)'
//               }}
//             />
//           )}
//         </div>
//       </div>

//       {/* Lightbox Modal */}
//       {isOpen && (
//         <div 
//           style={{
//             position: 'fixed',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             backgroundColor: 'rgba(0, 0, 0, 0.9)',
//             zIndex: 9999,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center'
//           }}
//           onClick={() => setIsOpen(false)}
//         >
//           <button
//             onClick={() => setIsOpen(false)}
//             style={{
//               position: 'absolute',
//               top: '20px',
//               right: '20px',
//               background: 'white',
//               border: 'none',
//               fontSize: '30px',
//               cursor: 'pointer',
//               width: '40px',
//               height: '40px',
//               borderRadius: '50%',
//               zIndex: 10000
//             }}
//           >
//             ×
//           </button>
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               const currentIndex = imageList.indexOf(mainImage);
//               const prevIndex = (currentIndex - 1 + imageList.length) % imageList.length;
//               setMainImage(imageList[prevIndex]);
//             }}
//             style={{
//               position: 'absolute',
//               left: '20px',
//               background: 'white',
//               border: 'none',
//               fontSize: '30px',
//               cursor: 'pointer',
//               width: '40px',
//               height: '40px',
//               borderRadius: '50%',
//               zIndex: 10000
//             }}
//           >
//             ‹
//           </button>
//           <img 
//             src={mainImage} 
//             alt="Product Full View"
//             style={{
//               maxWidth: '90%',
//               maxHeight: '90%',
//               objectFit: 'contain'
//             }}
//             onClick={(e) => e.stopPropagation()}
//           />
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               const currentIndex = imageList.indexOf(mainImage);
//               const nextIndex = (currentIndex + 1) % imageList.length;
//               setMainImage(imageList[nextIndex]);
//             }}
//             style={{
//               position: 'absolute',
//               right: '20px',
//               background: 'white',
//               border: 'none',
//               fontSize: '30px',
//               cursor: 'pointer',
//               width: '40px',
//               height: '40px',
//               borderRadius: '50%',
//               zIndex: 10000
//             }}
//           >
//             ›
//           </button>
//         </div>
//       )}
//     </>
//   );
// };

// const ProductView = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [product, setProduct] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [selectedSize, setSelectedSize] = useState("");
  
//   // Get product ID from URL params or use default
//   const getProductId = () => {
//     const urlParams = new URLSearchParams(window.location.search);
//     return urlParams.get('product_id');
//   };

//   useEffect(() => {
//     fetchProductDetails();
//   }, []);

//   const fetchProductDetails = async () => {
//     try {
//       setLoading(true);
//       const productId = getProductId();
//       const response = await fetch(
//         `https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id?product_id=${productId}`
//       );
//       const result = await response.json();
      
//       if (result.status) {
//         setProduct(result.data);
//       } else {
//         setError(result.message || "Failed to fetch product");
//       }
//     } catch (err) {
//       setError("Error fetching product details");
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOpen = () => setIsOpen(true);
//   const handleClose = () => setIsOpen(false);

//   const calculateDiscount = (current, old) => {
//     if (!old || !current) return 0;
//     return Math.round(((old - current) / old) * 100);
//   };

//   if (loading) {
//     return (
//       <div className="container-fluid model-section">
//         <div style={{ textAlign: 'center', padding: '50px' }}>
//           <h3>Loading product details...</h3>
//         </div>
//       </div>
//     );
//   }

//   if (error || !product) {
//     return (
//       <div className="container-fluid model-section">
//         <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>
//           <h3>Error: {error || "Product not found"}</h3>
//         </div>
//       </div>
//     );
//   }

//   const discount = calculateDiscount(
//     parseFloat(product.current_price),
//     parseFloat(product.old_price)
//   );
//   const availableSizes = product.available_size ? product.available_size.split(',') : ['S', 'M', 'L', 'XL', 'XXL'];
//   const availableColors = product.available_color ? product.available_color.split(',') : [];

//   return (
//     <div>
//       <div className="container-fluid model-section">
//         <div className="model-midsize">
//           Home / <span>Casual Shirts For Men</span>
//         </div>
//         <div className="row mt-5">
//           <div className="col-lg-6">
//             <div className="row model-row">
//               {/* Pass multi_image array to ProductImages component */}
//               <ProductImages images={product.multi_image} />
//             </div>
//           </div>
//           <div className="col-lg-6">
//             <div className="rightcontent">
//               <h3 className="pdp-title">{product.fashion_brand_name || product.company_name || 'Moda Rapido'}</h3>
//               <h3 className="pdp-name">{product.product_name}</h3>
//               <div className="ratebox">
//                 <p className="num">{product.rating || '3.7'}</p>
//                 <img src="img/star.png" alt="star" />
//                 <div className="separator">|</div>
//                 <span className="ratingnum">12.2k Ratings</span>
//               </div>
//               <div className="hr" />
//               <div className="disline">
//                 <span className="cost">Rs.{product.current_price}</span>
//                 <s className="totalcost">Rs.{product.old_price}</s>
//                 {discount > 0 && <span className="discount">({discount}% OFF)</span>}
//               </div>
//               <div className="smalltext">Inclusive of all taxes</div>
//               <div className="size-chart">
//                 <h4 className="size">SELECT SIZE</h4>
//                 <h4 className="chart">SIZE CHART</h4>
//                 <span className="size-button-arrow" />
//               </div>
//               <div className="sizes">
//                 {availableSizes.map((size, index) => (
//                   <div 
//                     key={index} 
//                     className={`circles ${selectedSize === size.trim() ? 'selected' : ''}`}
//                     onClick={() => setSelectedSize(size.trim())}
//                   >
//                     {size.trim()}
//                   </div>
//                 ))}
//               </div>
//               {/* <div className="newdiv">
//                 <Link to="/bag">
//                   <button className="cartbtn">
//                     <img src="img/bag.svg" alt="bag" />
//                     ADD TO BAG
//                   </button>
//                 </Link>
//                 <button className="wishbtn">
//                   <img src="img/heart.svg" alt="heart" />
//                   WISHLIST
//                 </button>
//               </div> */}

//               {/* <div className="delivary-section">
//                 <span>DELIVERY OPTIONS</span>
//                 <img className="van" src="img/van.jpg" alt="delivery" />
//               </div> */}

//               {/* <div className="checkbox">
//                 <input type="number" placeholder="Enter a pin code" />
//                 <h4 className="pin">
//                   Please enter PIN code to check delivery time &amp; Pay on
//                   Delivery Availability
//                 </h4>
//               </div> */}
//               <div className="bigtextcontainer">
//                 <div>
//                   <p className="bigtext">{product.description}</p>
//                 </div>
//                 {/* <div>
//                   <h4 className="bigtext">Pay on delivery might be available</h4>
//                 </div>
//                 <div>
//                   <h4 className="bigtext">Easy 30 days returns and exchanges</h4>
//                 </div>
//                 <div>
//                   <h4 className="bigtext">Try &amp; Buy might be available</h4>
//                 </div> */}
//               </div>
//               <div className="newdiv">
//                 <h4 className="font">
//                   BEST OFFERS
//                   <img className="tag" src="img/offer-key.png" alt="offer" />
//                 </h4>
//               </div>
//               <div>
//                 <h4 className="font">
//                   Best Price:<span className="orange"> Rs.84</span>
//                 </h4>
//               </div>
//               <ul className="items">
//                 <li>
//                   Applicable on: Orders above Rs. 2499 (only on first purchase)
//                 </li>
//                 <li>
//                   Coupon code: <b>MYNTRA400</b>
//                 </li>
//                 <li>
//                   Coupon Discount: Rs. 400 off (check cart for final savings)
//                 </li>
//               </ul>
//               <div className="smalltexter">View Eligible Products</div>
//               {product.emi_option && (
//                 <>
//                   <div>
//                     <h4 className="fot">EMI option available</h4>
//                   </div>
//                   <ul className="items-s">
//                     <li>{product.emi_option}</li>
//                   </ul>
//                   <div className="smalltexter">View Plan</div>
//                 </>
//               )}
//               <div className="hr" />
//               <div className="product-newdiv">
//                 <h4 className="font">PRODUCT DETAILS</h4>
//                 <h4 className="bigtext">
//                   {/* {product.description || 'Maroon and black printed T-shirt, has a round neck, long sleeves'} */}
//                 </h4>
//                 {product.product_details && (
//                   <h4 className="bigtext">{product.product_details}</h4>
//                 )}
//               </div>

//               <div className="products-newdiv">
//                 <h4 className="font">Size &amp; Fit</h4>
//               </div>
//               <div>
//                 <h4 className="bigtext-noGap">
//                   {product.fit_type || "The model (height 6') is wearing a size M"}
//                 </h4>
//               </div>
//               <div className="products-newdiv">
//                 <h4 className="font">Material &amp; Care</h4>
//               </div>
//               <div>
//                 <h4 className="bigtext-noGap">{product.material || '100% cotton'}</h4>
//               </div>
//               {product.care_instructions && (
//                 <div>
//                   <h4 className="bigtext-noGap">{product.care_instructions}</h4>
//                 </div>
//               )}
//               <div>
//                 <h4 className="bigtext-noGap">Machine-wash</h4>
//               </div>
//               <div className="products-newdiv">
//                 <h4 className="font">Specifications</h4>
//               </div>
//               <div className="index-tableContainer">
//                 {product.material && (
//                   <div className="index-row">
//                     <div className="index-rowKey">Fabric</div>
//                     <div className="index-rowValue">{product.material}</div>
//                   </div>
//                 )}
//                 {product.fit_type && (
//                   <div className="index-row">
//                     <div className="index-rowKey">Fit</div>
//                     <div className="index-rowValue">{product.fit_type}</div>
//                   </div>
//                 )}
//                 <div className="index-row">
//                   <div className="index-rowKey">Length</div>
//                   <div className="index-rowValue">Regular</div>
//                 </div>
//                 <div className="index-row">
//                   <div className="index-rowKey">Main Trend</div>
//                   <div className="index-rowValue">Abstract</div>
//                 </div>
//                 <div className="index-row">
//                   <div className="index-rowKey">Multipack Set</div>
//                   <div className="index-rowValue">Single</div>
//                 </div>
//                 <div className="index-row">
//                   <div className="index-rowKey">Neck</div>
//                   <div className="index-rowValue">Round Neck</div>
//                 </div>
//                 {product.occasion && (
//                   <div className="index-row">
//                     <div className="index-rowKey">Occasion</div>
//                     <div className="index-rowValue">{product.occasion}</div>
//                   </div>
//                 )}
//                 <div className="index-row">
//                   <div className="index-rowKey">Pattern</div>
//                   <div className="index-rowValue">Printed</div>
//                 </div>
//                 <div className="index-row">
//                   <div className="index-rowKey">Pattern Coverage</div>
//                   <div className="index-rowValue">Full-Front</div>
//                 </div>
//                 <div className="index-row">
//                   <div className="index-rowKey">Print or Pattern Type</div>
//                   <div className="index-rowValue">Abstract</div>
//                 </div>
//                 <div className="index-row">
//                   <div className="index-rowKey">Sleeve Length</div>
//                   <div className="index-rowValue">Long Sleeves</div>
//                 </div>
//                 <div className="index-row">
//                   <div className="index-rowKey">Sleeve Styling</div>
//                   <div className="index-rowValue">Regular Sleeves</div>
//                 </div>
//                 {availableColors.length > 0 && (
//                   <div className="index-row">
//                     <div className="index-rowKey">Available Colors</div>
//                     <div className="index-rowValue">{availableColors.join(', ')}</div>
//                   </div>
//                 )}
//                 {product.stock && (
//                   <div className="index-row">
//                     <div className="index-rowKey">Stock</div>
//                     <div className="index-rowValue">{product.stock} available</div>
//                   </div>
//                 )}
//               </div>
//               <hr />
//               <div className="rating-div">
//                 <h4>
//                   RATINGS
//                   <i className="fa-regular fa-star" style={{ width: "5%" }}></i>
//                 </h4>
//                 <div className="row">
//                   <div className="col-lg-3 col-md-3 col-sm-12 rating-div1">
//                     <h1>
//                       {product.rating || '4.3'} <i className="fa-solid fa-star"></i>
//                     </h1>
//                     <p>66 Verified Buyers</p>
//                   </div>
//                   <div className="col-lg-1 col-md-1 col-sm-12 rating-div-vl"></div>
//                   <div className="col-lg-6 col-md-6 col-sm-12 rating-div2">
//                     5 <i className="fa-solid fa-star"></i>{" "}
//                     <div className="hr-line">
//                       <div className="progress-fill"></div>
//                     </div>{" "}
//                     40
//                   </div>
//                 </div>
//               </div>
//               <hr />
//               <div className="row customer-review">
//                 <h5>Customer Photos</h5>
//                 <div className="customer-review-img">
//                   <img src="img/acc1.webp" alt="review 1" />
//                   <img src="img/acc2.webp" alt="review 2" />
//                   <img src="img/acc3.webp" alt="review 3" />
//                   <img src="img/acc4.webp" alt="review 4" />
//                   <img src="img/acc5.webp" alt="review 5" />
//                 </div>
//               </div>

//               <div className="row customer-reviews">
//                 <h5>Customer Reviews</h5>
//                 <div className="col-1 review">
//                   5 <i className="fa-solid fa-star"></i>
//                 </div>
//                 <div className="col-11 customer-review-img">
//                   <p>
//                     The product perfectly matches the Quality associated with the
//                     Raymond brand. The cloth is amazing in both texture and size.
//                     Feels light and airy when wore. If you are looking for a
//                     mid-priced trouser pant, I would suggest to go with Raymond
//                     without any doubts.
//                   </p>
//                   <img src="img/acc4.webp" alt="review" />
//                   <img src="img/acc5.webp" alt="review" />
//                 </div>
//               </div>
//               <hr />

//               <div className="seller-div">
//                 <p>
//                   Product Code: <strong>{product.product_id}</strong>
//                 </p>
//                 <p>
//                   Seller:{" "}
//                   <span>{product.assign_vendor || "RAYMOND LIFESTYLE LIMITED"}</span>
//                 </p>
//                 <div>
//                   <a onClick={handleOpen}>View Supplier Information</a>

//                   {/* {isOpen && <SupplierInfoModal onClose={handleClose} />} */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="row similar-product-section ">
//           <h3>Similar Product</h3>
//           <div className="products-card">
//             {[...Array(10)].map((_, index) => (
//               <div key={index}>
//                 <img src="img/slider1.webp" alt={`Similar product ${index + 1}`} />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       {/* <Footer /> */}
//     </div>
//   );
// };

// export default ProductView;

import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ProductView = () => {
  const { id } = useParams(); // get product_id from URL
  const [product, setProduct] = useState(null);

  useEffect(() => {
    fetchProduct();
  }, []);

  const fetchProduct = async () => {
    try {
      const formData = new FormData();
      formData.append("product_id", id);

      const res = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
        formData
      );

      if (res.data.status === true) {
        setProduct(res.data.data);
      } else {
        toast.error("Unable to fetch product details");
      }
    } catch (err) {
      console.log(err);
      toast.error("Error fetching product details");
    }
  };

  if (!product) {
    return (
      <div className="page-content">
        <div className="container-fluid text-center py-5">
          <h4>Loading Product...</h4>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* PAGE HEADER */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Product Details</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item"><Link to="/product-list">Products</Link></li>
                <li className="breadcrumb-item active">{product.product_name}</li>
              </ol>
            </div>
          </div>
        </div>

        {/* PRODUCT CARD */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="row">

                  {/* IMAGE BLOCK */}
                  <div className="col-md-4 text-center">
                    <img
                      src={
                        product.multi_image && product.multi_image.length > 0
                          ? `https://cyberathon.com/multivendor/${product.multi_image[0]}`
                          : "https://via.placeholder.com/400x300?text=No+Image"
                      }
                      alt={product.product_name}
                      className="img-fluid rounded shadow"
                    />
                  </div>

                  {/* DETAILS BLOCK */}
                  <div className="col-md-8">
                    <h3 className="fw-bold">{product.product_name}</h3>
                    <p className="text-muted">{product.description}</p>

                    <h4 className="text-primary">₹{product.current_price}</h4>
                    <p className="text-muted text-decoration-line-through">
                      {product.old_price ? `₹${product.old_price}` : ""}
                    </p>

                    <p><strong>Company:</strong> {product.company_name || "N/A"}</p>
                    <p><strong>Model:</strong> {product.model_name || "N/A"}</p>

                    {/* PRODUCT SPECS */}
                    <div className="row mt-3">
                      <div className="col-md-6">
                        <p><strong>RAM:</strong> {product.ram || "N/A"}</p>
                        <p><strong>ROM:</strong> {product.rom || "N/A"}</p>
                        <p><strong>Processor:</strong> {product.processor || "N/A"}</p>
                        <p><strong>Camera:</strong> {product.camera || "N/A"}</p>
                        <p><strong>Battery:</strong> {product.battery || "N/A"}</p>
                      </div>

                      <div className="col-md-6">
                        <p><strong>Weight:</strong> {product.weight || "N/A"}</p>
                        <p><strong>Dimension:</strong> {product.dimension || "N/A"}</p>
                        <p><strong>OS:</strong> {product.operating_system || "N/A"}</p>
                        <p><strong>Available Size:</strong> {product.available_size || "N/A"}</p>
                        <p><strong>Available Color:</strong> {product.available_color || "N/A"}</p>
                        <p><strong>Stock:</strong> {product.stock}</p>
                        <p><strong>Rating:</strong> ⭐ {product.rating}</p>
                      </div>
                    </div>

                    <p className="mt-3"><strong>Vendor:</strong> {product.assign_vendor}</p>

                    {/* STATUS */}
                    <p>
                      <strong>Status:</strong>{" "}
                      <span className={`badge 
                        ${product.status === "Instock" ? "bg-success-subtle text-success"
                          : product.status === "fewleft" ? "bg-warning-subtle text-warning"
                          : "bg-danger-subtle text-danger"} py-1 px-2`}>
                        {product.status}
                      </span>
                    </p>

                    <p><strong>Created:</strong> {product.created_at}</p>

                  </div>
                </div>
              </div>

              {/* BACK BUTTON */}
              <div className="card-footer text-end">
                <Link to="/product-list" className="btn btn-primary">
                  Back to Product List
                </Link>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ProductView;
